/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseConsumptionAnalyticsDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseLeakTrendsDTO } from '../backend/model';
/**
 * SuperAdminAnalyticsControllerApi - axios parameter creator
 * @export
 */
export const SuperAdminAnalyticsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [period] 
         * @param {number} [councilId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsumptionAnalytics: async (period?: string, councilId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/consumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (councilId !== undefined) {
                localVarQueryParameter['councilId'] = councilId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] Start date for the leak trends date range (ISO 8601)
         * @param {string} [to] End date for the leak trends date range (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeakTrends: async (from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/analytics/leak-trends`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuperAdminAnalyticsControllerApi - functional programming interface
 * @export
 */
export const SuperAdminAnalyticsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuperAdminAnalyticsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [period] 
         * @param {number} [councilId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsumptionAnalytics(period?: string, councilId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConsumptionAnalyticsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsumptionAnalytics(period, councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperAdminAnalyticsControllerApi.getConsumptionAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] Start date for the leak trends date range (ISO 8601)
         * @param {string} [to] End date for the leak trends date range (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeakTrends(from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseLeakTrendsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeakTrends(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperAdminAnalyticsControllerApi.getLeakTrends']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuperAdminAnalyticsControllerApi - factory interface
 * @export
 */
export const SuperAdminAnalyticsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuperAdminAnalyticsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [period] 
         * @param {number} [councilId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsumptionAnalytics(period?: string, councilId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConsumptionAnalyticsDTO> {
            return localVarFp.getConsumptionAnalytics(period, councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [from] Start date for the leak trends date range (ISO 8601)
         * @param {string} [to] End date for the leak trends date range (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeakTrends(from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseLeakTrendsDTO> {
            return localVarFp.getLeakTrends(from, to, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuperAdminAnalyticsControllerApi - object-oriented interface
 * @export
 * @class SuperAdminAnalyticsControllerApi
 * @extends {BaseAPI}
 */
export class SuperAdminAnalyticsControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [period] 
     * @param {number} [councilId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperAdminAnalyticsControllerApi
     */
    public getConsumptionAnalytics(period?: string, councilId?: number, options?: RawAxiosRequestConfig) {
        return SuperAdminAnalyticsControllerApiFp(this.configuration).getConsumptionAnalytics(period, councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [from] Start date for the leak trends date range (ISO 8601)
     * @param {string} [to] End date for the leak trends date range (ISO 8601)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperAdminAnalyticsControllerApi
     */
    public getLeakTrends(from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return SuperAdminAnalyticsControllerApiFp(this.configuration).getLeakTrends(from, to, options).then((request) => request(this.axios, this.basePath));
    }
}

